import { Skeleton } from '@mui/material';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import { CatchUpInvoice } from '../../../types/catchUps';
import {
	INVALIDATE_INVOICE_MODAL__BODY_TEXT_TITLE,
	INVALIDATE_INVOICE_MODAL__CANCEL,
	INVALIDATE_INVOICE_MODAL__LOADING,
	INVALIDATE_INVOICE_MODAL__SUBMIT,
	INVALIDATE_INVOICE_MODAL__TITLE,
} from '../data/constants';

interface InvalidateInvoiceModalProps {
	open: boolean;
	invoice: CatchUpInvoice;
	handleClose: () => void;
	callback: (invoiceLocator: string, policyLocator: string) => Promise<void>;
	isCatchUp: boolean;
}

const InvalidateInvoiceModal = (props: InvalidateInvoiceModalProps) => {
	const [formWizard, setFormWizard] = useState<
		'initial' | 'loading' | 'error' | 'success'
	>('initial');
	const { open, handleClose, invoice, callback, isCatchUp } = props;

	return (
		<Dialog open={open} onClose={handleClose}>
			<Collapse in={formWizard === 'initial'}>
				<DialogTitle>{INVALIDATE_INVOICE_MODAL__TITLE(isCatchUp)}</DialogTitle>
				<DialogContent>
					{INVALIDATE_INVOICE_MODAL__BODY_TEXT_TITLE(
						invoice.displayId,
						isCatchUp,
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color='neutralButton'>
						{INVALIDATE_INVOICE_MODAL__CANCEL}
					</Button>
					<Button
						onClick={async () => {
							setFormWizard('loading');
							await callback(invoice.locator, invoice.policyLocator);
							handleClose();
						}}
						autoFocus
						color='primary'
						variant='contained'
					>
						{INVALIDATE_INVOICE_MODAL__SUBMIT(isCatchUp)}
					</Button>
				</DialogActions>
			</Collapse>
			<Collapse in={formWizard === 'loading'}>
				<DialogTitle>
					{INVALIDATE_INVOICE_MODAL__LOADING(isCatchUp)}
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<Skeleton variant='text' />
					</DialogContentText>
				</DialogContent>
			</Collapse>
		</Dialog>
	);
};

export default InvalidateInvoiceModal;
